module.exports = __webpack_public_path__ + "assets/01.28a6abe5.pdf";